import { css } from 'lit';
export const styles = css `
:host{outline:none!important}:host(:focus){outline:0}.wrapper{align-items:center;box-sizing:border-box;display:flex;width:fit-content}.wrapper ::slotted(hds-tab){height:100%!important}.hds-tab-bar--variant-default{height:3rem}.hds-tab-bar--variant-wide{height:4rem}
`;
//# sourceMappingURL=hds-tab-bar.css.js.map